module.exports = __webpack_public_path__ + "static/media/cover-egypt.eb22ec4d.jpg";